import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { Navigator } from "src/app/services/routing/navigator";
import { EventsService } from "src/app/services/event/event.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Campaign } from "src/app/interfaces/campaign-interface";
import { BonusService } from "src/app/services/bonus/bonus.service";
import { Subscription } from "rxjs";
import { IPromotion } from "src/app/interfaces/player-dashboard.interface";
import { RoutingService } from "src/app/services/routing/routing.service";

@Component({
  selector: "app-promotion-action-buttons",
  templateUrl: "./promotion-action-buttons.component.html",
  styleUrls: ["./promotion-action-buttons.component.scss"],
})

export class PopoverPromotionActionButtonsComponent implements OnDestroy {
  depositEventSubscription: Subscription;
  @Input() promoDataVal: IPromotion;

  @Output() openDetail: EventEmitter<Campaign> = new EventEmitter();
  private callGetCustomerCasinoBonusSubscriptions: Subscription;

  public isLoggedIn = false;

  get isCouponCodeCampaign(): boolean {
    return this.promoDataVal?.campaign_type === 'COUPON_CODE' || this.promoDataVal?.campaign_type === 'LEADERBOARD' || (this.promoDataVal?.campaign_type === 'DRAW' && this.promoDataVal?.offer_type === 'LOYALTY_DRAW_ENTRY');
  }

  constructor(
    private bonusService: BonusService,
    private bonusSrvc: BonusService,
    private events: EventsService,
    private navigator: Navigator,
    private routing: RoutingService,
    private userSession: UserSessionService,
  ) {
    this.isLoggedIn = this.userSession.isAuthenticated();
  }

  public openBonusDetails(value) {
    this.callGetCustomerCasinoBonusSubscriptions = this.bonusSrvc
      .callGetCustomerCasinoBonus(value.customer_casino_bonus_id)?.subscribe((resData) => {
        this.navigator.navigateTo(
          "BonusDetailsComponent",
          { multipleModals: true },
          { bonus: resData?.payload, hideBack: true }
        );
      });
  }

  public depositClick() {
    this.navigator.dismissAll();
    this.events.subscribe('event:lobby:show', () => {
      this.bonusSrvc.setPromoReload(true);
    });
  }

  public openMyFreeSpinsPage() {
    this.navigator.navigateTo("MyFreeSpinComponent", {}, { hideBack: true });
  }

  public openRafInvitePage() {
    this.navigator.navigateTo("RafInviteEmailComponent", { multipleModals: false }, { source: 'promotions' });
  }

  ngOnDestroy(): void {
    this.callGetCustomerCasinoBonusSubscriptions?.unsubscribe();
  }

  public moreInfo(promo: IPromotion) {
    this.bonusService.setPromoDetailInfo({ id: promo.id });
    this.navigator.dismissAll('');
    this.routing.toPromotionsTab();
  }

}
